var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavBefore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.9998C7 11.713 7.12005 11.4263 7.35964 11.2077L14.9028 4.32804C15.3826 3.89041 16.1606 3.89041 16.6403 4.32804C17.1199 4.7655 17.1199 5.47491 16.6403 5.91258L9.96565 11.9998L16.64 18.087C17.1197 18.5247 17.1197 19.234 16.64 19.6714C16.1604 20.1093 15.3824 20.1093 14.9026 19.6714L7.3594 12.7919C7.11978 12.5732 7 12.2864 7 11.9998Z",
    fill: "#323740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavBefore);
export default __webpack_public_path__ + "static/media/icon-nav_before.1fe7b1683b150e6ac4e0fc13d5e270cb.svg";
export { ForwardRef as ReactComponent };